import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'posSearch'
})
export class PosSearchPipe implements PipeTransform {

  transform(items:any,Type:any,SearchString:any): unknown {
    return null;
  }

}
